<template>
    <div id="button"
        :class="{ 'active' : isButtonActive }"
        @click.prevent="toggle">
        <slot>
            <button type="button" class="burger-button" title="Menu">
                <span class="burger-bar burger-bar--1"></span>
                <span class="burger-bar burger-bar--2"></span>
                <span class="burger-bar burger-bar--3"></span>
            </button>
        </slot>
    </div>
</template>
<script>
    import { store, mutations } from '@/store.js'

    export default {
        computed: {
            isButtonActive() {
                return store.isNavOpen
            }
        },
        methods: {
            toggle() {
                mutations.toggleNav()
            }
        }
    }
</script>
<style lang="scss">
    .hidden { visibility: hidden; }

    button { cursor: pointer; }

    .burger-button {
        position: relative;
        height: 30px;
        width: 32px;
        display: block;
        z-index: 999;
        border: 0;
        border-radius: 0;
        background-color: transparent;
        pointer-events: all;
        transition: transform .6s cubic-bezier(.165,.84,.44,1);
    }

    .burger-bar {
        background-color: $brand-color;
        position: absolute;
        top: 50%;
        right: 6px;
        left: 6px;
        height: 2px;
        width: auto;
        margin-top: -1px;
        transition: transform .6s cubic-bezier(.165,.84,.44,1),opacity .3s cubic-bezier(.165,.84,.44,1),background-color .6s cubic-bezier(.165,.84,.44,1);
    }

    .burger-bar--1 {
        -webkit-transform: translateY(-6px);
        transform: translateY(-6px);
    }

    .burger-bar--3 { transform: translateY(6px); }

    #button {
        position: absolute;
        top: 33px;
        right: 1.25rem;
        z-index: 1000;
        width: fit-content;

        &.active {
            .burger-button { transform: rotate(-180deg); }
            .burger-bar { background-color: $brand-color; }
            .burger-bar--1 { transform: rotate(45deg) }
            .burger-bar--2 { opacity: 0; }
            .burger-bar--3 { transform: rotate(-45deg) }
        }
    }

    @media screen and (min-width: 768px) {
        #button {
            left: 1.25rem;
        }
    }
</style>